import React, { FunctionComponent, useEffect, useRef } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../init-store';
import css from './video.css';

const mapState = (state: RootState, ownProps: VideoOwnProps) => ({
    videoInputDeviceId: state.settings.media.videoInputDeviceId,
    videoTrack: ownProps.videoStream?.getVideoTracks()[0],
});

const connector = connect(mapState, {});

type VideoOwnProps = {
    videoStream?: MediaStream;
    className?: string;
    stretchVideo?: boolean;
};

type VideoConnectedProps = ConnectedProps<typeof connector>;

const Video: FunctionComponent<VideoConnectedProps & VideoOwnProps> = ({
    videoStream,
    className,
    stretchVideo = true,
    videoInputDeviceId,
    videoTrack,
}) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        if (videoStream && videoRef.current) {
            const videoEl = videoRef.current;

            videoEl.srcObject = videoStream;

            return () => {
                videoEl.srcObject = null;
            };
        }

        // Мы тригерим изменение только в том случае, когда меняется именно видеотрек внутри стрима. Сама обертка в
        // виде стрима нам не так важна и не должна приводить к морганиям
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoInputDeviceId, videoTrack]);

    return (
        <video
            ref={videoRef}
            className={cn(className, css.ActiveVideo, {
                [css.containMode]: !stretchVideo,
            })}
            autoPlay
            // remove YaBro custom buttons https://st.yandex-team.ru/CHEMODAN-71816
            // eslint-disable-next-line react/no-unknown-property
            x-yandex-pip="false"
            playsInline
        />
    );
};

export default connector(Video);
